import { connect } from "react-redux";
import { Content as Component } from "./Content";

interface TimerInterface {
  hours: number;
  minutes: number;
  seconds: number;
}

interface MicroplateReaderState {
  wavelength: number;
  temperature: number;
  isShakeOn: boolean;
  timer: TimerInterface;
}

interface MicroplateState {
  wellsContent: Record<`${string}${number}`, { [key: string]: number }>;
}

interface RootState {
  microplateReader?: MicroplateReaderState;
  microplate?: MicroplateState;
}

interface OwnProps {
  [key: string]: unknown;
}

interface MapStateToProps {
  wavelength: number;
  temperature: number;
  isShakeOn: boolean;
  timer: TimerInterface;
  wellsContent: Record<`${string}${number}`, { [key: string]: number }>;
}

function mapStateToProps(
  state: RootState,
  ownProps: OwnProps
): MapStateToProps {
  return {
    ...ownProps,
    wavelength: state["microplateReader"]?.wavelength || 0,
    temperature: state["microplateReader"]?.temperature || 0,
    isShakeOn: state["microplateReader"]?.isShakeOn || false,
    timer: state["microplateReader"]?.timer || {
      hours: 0,
      minutes: 0,
      seconds: 0,
    },
    wellsContent: state["microplate"]?.wellsContent || {},
  };
}

export const ContentRedux = connect(mapStateToProps)(Component);
